<script lang="ts">
  import Lazy from 'svelte-lazy';
  import { PUBLIC_STRAPI_MEDIA } from '$env/static/public';
  import type { TwoColComponent } from "$lib/js/strapi/types";

  export let component: TwoColComponent

  let image = component?.image || {};
  let image2 = component?.image2 || {};
</script>


<div class="two-col">
  <div class="two-col__inner">
    <div class="two-col__col">
      {#if image}
        <Lazy height={200}>
          <img src="{PUBLIC_STRAPI_MEDIA}{image.url}" title="{component.title}" alt="{component.title}">
        </Lazy>
      {/if}

      <h2>{component.title}</h2>
      <p>{@html component.description}</p>
    </div>

    <div class="two-col__col">
      {#if image2}
        <Lazy height={200}>
          <img src="{PUBLIC_STRAPI_MEDIA}{image2.url}" title="{component.title2}" alt="{component.title2}">
        </Lazy>
      {/if}

      <h2>{component.title2}</h2>
      <p>{@html component.description2}</p>
    </div>
  </div>
</div>


<style lang="scss">
  .two-col {
    margin: 25px 0;

    @media (min-width: 769px) {
      margin: 50px 0;
    }

    &__inner {
      @media (min-width: 769px) {
        display: flex;
        justify-content: space-between;
      }
    }

    &__col {
      @media (min-width: 769px) {
        width: 46%;
      }

      img {
        max-width: 100%;
        margin-bottom: 15px;
      }
    }
  }
</style>
